<template>
    <div class="earlyWarning">
        <div class="main_list" >
            <div class="s_city" @click="changShow()" v-show="this.tabNum !== 0">
                <img src="../../../../../assets/image/select.png" v-if="!isShow" />
                <img src="../../../../../assets/image/no_select.png" v-if="isShow" />
            </div>
            <van-list
                ref="vanList"
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                @load="onLoad"
                class="wrapper"
            >
                <div
                class="reject"
                v-for="(item,index) in proList"
                :key="index"
                @click="goDetail(item)"
                >
                <div class="reject_item">
                    <div class="box_item">
                        <div class="title">
                            <p class="title_text">{{item.defendantName}}</p>
                            <p class="title_tag1" :class="sstt[item.urgency_degree == '' ? '': Number(item.urgency_degree-7)]">{{sttText[item.urgency_degree == '' ? '': Number(item.urgency_degree-7)]}}</p>
                        </div>
                        <div class="info1">
                            <span></span><span>{{item.belong_mechanism_name}}</span>
                        </div>
                        <div class="info">
                            <span>投诉人姓名:</span>
                            <span>{{item.complain_name}}</span>
                        </div>
                        <div class="info">
                            <span>投诉时间:</span>
                            <span>{{item.complain_time}}</span>
                        </div>
                        <div class="info">
                            <span>投诉单号:</span>
                            <span>{{item.main_complain_number}}</span>
                        </div>
                        <div class="info">
                            <span>处置状态:</span>
                            <span class="info_time">{{item.handle_time|filt3()}}</span>
                            <span></span>
                            <span>{{item.handle_time_limit|filt4()}}</span>
                        </div>
                    </div>
                    <div class="line line_bottom"></div>
                    <div class="status">
                        <p>{{item.statue_name}}</p>
                        <p>
                            <span>查看详情</span>
                            <span>
                                <img src="../../../../../assets/image/right.png" alt="">
                            </span>
                        </p>
                    </div>
                </div>
                <!-- <div class="space"></div> -->
                </div>
            </van-list>
        </div>
        <isNoInfo :isNolist="isNolist"></isNoInfo>
    </div>
</template>
<script>
    import api from '../../../../../service/modules/complaint';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    import util from '../../../../../utils/common';
    export default {
        components: {
            isNoInfo
        },
        data () {
            return {
                tabNum: 0,
                sstt: [
                    'ss1',
                    'ss2',
                    'ss3'
                ],
                sttText: [
                    '一般',
                    '较重',
                    '严重'
                ],
                proList: [],
                pageIndex: '0',
                pageSize: '10',
                cityList: [],
                cityList4: [],
                finished: false,
                finishedText: '没有更多',
                loading: true,
                isNolist: false,
                isShow: false,
                cityValue: '',
                areaId: this.$route.query.areaOne,
                pointType: 'timeOut',
                type: this.$route.query.typeSign,
                emergencyType: this.$route.query.dafaultType

            }
        },
        created () {
            this.getList();
        },
        methods: {
            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.$store.commit('complaint/setCheckList', false);
            },
            getList () {
                this.proList = [];
                this.pageIndex = 1;
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: this.type,
                    emergencyType: this.emergencyType,
                    place: this.areaId
                }
                api.newWorkbenchList(data).then(res => {
                    this.loading = false; // 加载参数
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = res.data.list;
                        if (res.data.list.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                })
            },
            getMore () {
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: this.type,
                    emergencyType: this.emergencyType,
                    place: this.areaId
                }
                api.newWorkbenchList(data).then((res) => {
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = this.proList.concat(res.data.list);
                        if (this.proList.length === res.data.totalSize) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                })
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            },
            changShow () {
                this.isShow = !this.isShow;
            }
        },
        filters: {
            // 时长计算
            filt3 (value) {
                var theTime = parseInt(value);// 秒
                var middle= 0;// 分
                var hour= 0;// 小时

                if(theTime > 60) {
                    middle= parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(middle> 60) {
                        hour= parseInt(middle/60);
                        middle= parseInt(middle%60);
                    }
                }
                var result = ""+parseInt(theTime)+"秒";
                if(middle > 0) {
                    result = ""+parseInt(middle)+"分"+result;
                }
                if(hour> 0) {
                    result = ""+parseInt(hour)+"小时"+result;
                }
                return result;

            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60 % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times
            }
        }
    }
</script>
<style lang="less" scoped>
.earlyWarning {
    width:100%;
    height:100%;
    background-color: @base-background;
    .main_list {
        background-color: #fafafa;
        .s_city {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #efefef;
            img {
                display: inline-block;
                width: 100px;
                height: 24px;
            }
        }
        .wrapper {
            background-color: #fafafa;
            padding-top: 16px;
            .reject {
                width: 100%;
                background-color: #fafafa;
                padding-bottom:16px;
                .reject_item {
                    margin-left: 12px;
                    margin-right: 12px;
                    padding-bottom: 0;
                    box-sizing: border-box;
                    background-color: #ffffff;
                    box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
                    border-radius: 3px;
                    .box_item{
                     width:100%;
                     padding: 16px;
                     box-sizing: border-box;
                    .title {
                        display: flex;
                        justify-content: space-between;
                        .title_text {
                            font-size: 16px;
                            font-weight: 700;
                            color: #2a2a2a;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            width: 90%;
                            line-height: 30px;
                            height: 30px;
                        }
                        .title_tag {
                            width: 36px;
                            height: 18px;
                            font-size: 10px;
                            color: #FFFFFF;
                            border-radius: 9px;
                            text-align: center;
                            line-height: 18px;
                        }
                        .ss1{
                            background: #118BF5;
                        }
                        .ss2{
                            background: #FFA509;
                        }
                        .ss3{
                            background: #F75C32;
                        }
                    }

                    .info {
                        margin-top: 12px;
                        span:nth-child(1) {
                            display: inline-block;
                            width: 84px;
                            font-size: 14px;
                            color: #777;
                        }
                        span:nth-child(2) {
                            display: inline-block;
                            font-size: 14px;
                        }
                        span:nth-child(3) {
                            display: inline-block;
                            content: '';
                            margin: -8px 5px;
                            background: #999;
                            width: 1px;
                            height: 16px;
                            -webkit-transform: scaleY(0.5);
                            transform: scale(0.5);
                            -webkit-transform-origin: 0 0;
                            transform-origin: 0 0;
                        }
                        span {
                            font-size: 14px;
                            color: #777;

                        }
                        .info_time {
                            color: #36B374;
                        }
                    }
                    .info1 {
                        margin-top: 12px;
                        span:nth-child(2) {
                            font-size:14px;
                            font-weight:400;
                            color:rgba(143,143,143,1);
                            line-height:14px;
                        }

                    }
                    }
                    .line {
                        width: 100%;
                        height: 1px;
                        // background-color: #eee;
                        margin-top: 2px;
                    }
                    .status {
                        width: 100%;
                        padding: 15px 14px;
                        font-size: 14px;
                        color: #333333;
                        font-weight: 400;
                        display: flex;
                        justify-content: space-between;
                        box-sizing: border-box;
                        p:nth-child(2) {
                            display: flex;
                            align-items: center;
                            span {
                                color: #999999;
                                font-size: 12px;
                            }
                        }
                        p>span>img {
                            width: 4px;
                            height: 7px;
                            margin-left: 4px;
                            margin-top:-3px;
                        }
                    }
                }
                .space {
                    width: 100%;
                    height: 24px;
                    background-color: #fafafa;
                }
            }
        }
    }
}
</style>
